﻿import {parentElement} from "@2d-front-monorepo/core";
import {getParentScrollable, IMvvmBaseContextState, scrollIntoView} from "@2d-front-monorepo/design-library";
import {RefObject, useEffect, useRef} from "react";


export function useScrollToFirstError(context: IMvvmBaseContextState): RefObject<HTMLFormElement | null> {
	const formRef = useRef<HTMLFormElement>(null);
	const isInvalid = context.isInvalid();
	useEffect(() => {
		if (isInvalid && formRef.current) {
			const errorElement = formRef.current.querySelector(".field__label--error") as HTMLElement;
			if (!errorElement) return;
			const labeled = parentElement(errorElement, ".labelled-field");
			if (!labeled) return;
			const scrollable = getParentScrollable(labeled);
			if (!scrollable) return;
			scrollIntoView(scrollable, labeled, "top", "smooth");
		}
	}, [isInvalid]);

	return formRef;
}
